import React from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import LockOutlined from "@mui/icons-material/LockOutlined";

export default function UnauthorizedPage() {
  const location = useLocation();
  const from = location.state?.from || null;

  return (
    <Box
      sx={{
        minHeight: "60vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
        py: 6,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          width: "100%",
          maxWidth: 560,
          p: { xs: 3, sm: 4 },
          borderRadius: 3,
          border: "1px solid",
          borderColor: "divider",
          textAlign: "center",
        }}
      >
        <Stack spacing={2.5} alignItems="center">
          <Box
            sx={{
              width: 64,
              height: 64,
              borderRadius: "50%",
              display: "grid",
              placeItems: "center",
              bgcolor: "action.hover",
              color: "warning.main",
            }}
          >
            <LockOutlined fontSize="large" />
          </Box>

          <Box>
            <Typography variant="h4" fontWeight={700} gutterBottom>
              Unauthorized
            </Typography>
            <Typography color="text.secondary">
              You do not have permission to open this page with your current role.
            </Typography>
            {from && (
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ mt: 1.25, wordBreak: "break-word" }}
              >
                Blocked URL: {from}
              </Typography>
            )}
          </Box>

          <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5}>
            <Button component={RouterLink} to="/dashboard" variant="contained">
              Go to dashboard
            </Button>
            <Button component={RouterLink} to="/admin" variant="outlined">
              Go to staff home
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </Box>
  );
}
